<template>
	<div class="search-modal">
		<button  @click.prevent="openModal" class="rtl:ml-2 focus:outline-none"  aria-label="search">
			<i class="icon icon-magnifier"></i>               
		</button>
		<div :class="{'modal' : true ,  'is-active' : isActive }">
			<div class="modal-background bg-black opacity-75"></div>
			<div class="modal-card w-11/12 md:w-1/2  rounded-md">
				<div class="modal-header text-left">
					<button class="text-white focus:outline-none" aria-label="close" @click="closeModal">
						<i class="fas fa-times-circle"></i>
					</button>
				</div>
				<div class="modal-body">
					<slot></slot>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "SearchModal",
		data() {
			return {
				isActive: false,
			};
		},
		methods: {
			openModal() {
				this.isActive = true;

			},
			closeModal(){
				this.isActive = false;
			}

		},

	};
</script>
<style>

</style>


// WEBPACK FOOTER //
// resources/assets/js/front/components/SearchModal.vue